import React from "react";
// import { useSelector } from "react-redux";
import Input from "../../../../components/inputs/inputs";
// import Button from "../../../../components/buttons/buttons";
// import { Beat } from "../../../../plugins/spinners.plugin";
// import { ShipperOperatingHours } from "../../../../components/modals/admin/shippers/shipperOperatingHours";

export default function ShippersRate2({
  handleChange,
  data,
  handleSubmit,
  submitted,
  // setData,
}) {
  // const { creating } = useSelector((state) => state.shipper);

  // useEffect(() => {
  //   if (!data.base_fees_by_delivery_mode?.length) {
  //     setData((prev) => ({
  //       ...prev,
  //       base_fees_by_delivery_mode: [{ title: "", charge: "", category: "" }],
  //     }));
  //   }
  //   // eslint-disable-next-line
  // }, []);
  const {
    weight_limit_by_kilogram,
    // base_fees_by_delivery_mode,
    base_fee_per_kilogram,
    vat_percentage,
    discount_percentage,
  } = data;


  // const checkSubmit = () => {
  //   let latest = {};

  //   // if (base_fees_by_delivery_mode?.length < 1) {
  //   //   latest["base_fees_by_delivery_mode"] = {
  //   //     title: "",
  //   //     charge: "",
  //   //     category: "",
  //   //   };
  //   // }

  //   setData((data) => ({
  //     ...data,
  //     // base_fees_by_delivery_mode: base_fees_by_delivery_mode,
  //     base_fee_per_kilogram: base_fee_per_kilogram,
  //   }));
  //   // handleSubmit();
  //   handleSubmit(latest);
  // };
  return (
    <div>
      <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-md py-5 px-4 sm:px-8">
        <div className="border-b border-[#E4E4F3] py-4 flex justify-between items-center mb-6">
          <h3 className="text-lg font-medium">Create Shipper Rates</h3>
        </div>
        <form name="form" id="shippers-form" onSubmit={(e) => handleSubmit(e)}>

          <div className="mb-10">
            <div className="border border-gray-300 py-2 px-2 mb-2">
              <h3 className="block text-lg font-bold text-[#151515] dark:text-white">
                Discount Percentage (%) :
              </h3>
              <p className="text-[#4D4D4DB2] dark:text-[#BCBCBC] text-sm">
                This is a company's discount margin.
              </p>
            </div>
            <Input.Label
              title={"Discount Percentage"}
              value={discount_percentage}
              htmlFor={"discount_percentage"}
              name={"discount_percentage"}
              placeholder={"Enter discount percentage"}
              onChange={handleChange}
            />
            {submitted && !discount_percentage && (
              <div className="text-primary text-xs ">
                Discount rate is required
              </div>
            )}
          </div>

          <div className="mb-8">
            <div className="border border-gray-300 py-2 px-2 mb-2">
              <h3 className="block text-lg font-bold text-[#151515] dark:text-white">
                Maximum supported weight (Kg) :
              </h3>
              <p className="text-[#4D4D4DB2] dark:text-[#BCBCBC] text-sm">
                The maximum supported weight per delivery depending on the category.
              </p>
            </div>
            <Input.Label
              title={"Maximum Weight"}
              htmlFor={"weight_limit_by_kilogram"}
              name={"weight_limit_by_kilogram"}
              placeholder={"Enter maximum weight"}
              value={weight_limit_by_kilogram}
              onChange={handleChange}
            />
            {submitted && !weight_limit_by_kilogram && (
              <div className="text-primary text-xs ">
                Maximum weight is required
              </div>
            )}
          </div>

          <div className="mb-8">
            <div className="border border-gray-300 py-2 px-2 mb-2">
              <h3 className="block text-lg font-bold text-[#151515] dark:text-white">
                Charge per weight (1kg) :
              </h3>
              <p className="text-[#4D4D4DB2] dark:text-[#BCBCBC] text-sm">
                This is the charge per weight of customer item depending on
                category.
              </p>
            </div>
            <div>
              <Input.Label
                title={"Charge Per Weight"}
                htmlFor={"base_fee_per_kilogram"}
                name={"base_fee_per_kilogram"}
                placeholder={"E.g 500"}
                onChange={handleChange}
              />
              {submitted && !base_fee_per_kilogram && (
                <div className="text-primary text-xs ">
                  Charge per weight is required
                </div>
              )}
            </div>
          </div>

          <div className="mb-8">
            <div className="border border-gray-300 py-2 px-2 mb-2">
              <h3 className="block text-lg font-bold text-[#151515] dark:text-white">
                VAT Percentage (%) :
              </h3>
              <p className="text-[#4D4D4DB2] dark:text-[#BCBCBC] text-sm">
                This is a company's VAT.
              </p>
            </div>
            <div>
              <Input.Label
                title={"VAT Percentage"}
                htmlFor={"vat_percentage"}
                name={"vat_percentage"}
                placeholder={"Enter VAT percentage"}
                onChange={handleChange}
              />
              {submitted && !vat_percentage && (
                <div className="text-primary text-xs ">
                  VAT percentage is required
                </div>
              )}
            </div>
          </div>

          {/* <div>
              <div className="border border-gray-300 py-2 px-2 mb-2">
                <h3 className="block text-lg  font-bold text-[#151515] dark:text-white">
                  Cost Per Delivery Mode :
                </h3>
                <p className="text-[#4D4D4DB2] dark:text-[#BCBCBC] text-sm">
                  This is the cost per vehicle type
                </p>
              </div>
              {base_fees_by_delivery_mode?.map((element, index) => (
                <div key={index}>
                  <div className="grid grid-cols-2 gap-2">
                    <Input.Label
                      title={"Vehicle"}
                      htmlFor={"title"}
                      name={"title"}
                      onChange={(e) => handleDynamicChange(e, index)}
                      placeholder={"EG: Car, Bike, Airplane"}
                      defaultValue={element.title || ""}
                    />
                    <div>
                      <Input.Label
                        title={"Charge"}
                        htmlFor={"charge"}
                        name={"charge"}
                        onChange={(e) => handleDynamicChange(e, index)}
                        placeholder={"NGN 500"}
                        defaultValue={element.charge || ""}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <div>
                      <Input.Select
                        title={"Category"}
                        htmlFor={"category"}
                        name={"category"}
                        placeholder={"NGN 500"}
                        onChange={(e) => handleDynamicChange(e, index)}
                        defaultValue={element.category || ""}
                      >
                        <option>Select a category</option>
                        <option value={"fragile"}>Fragile</option>
                        <option value={"none fragile"}>Non-Fragile</option>
                      </Input.Select>
                      {submitted && !base_fees_by_delivery_mode && (
                        <div className="text-primary text-xs ">
                          Category is required
                        </div>
                      )}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-[#151515] dark:text-white mb-2">
                        Operating Hours
                      </label>
                      <ShipperOperatingHours
                        index={index}
                        data={data}
                        setData={setData}
                      />
                      {submitted && !base_fees_by_delivery_mode && (
                        <div className="text-primary text-xs ">
                          Operating Hours is required
                        </div>
                      )}
                    </div>
                  </div>

                  {base_fees_by_delivery_mode?.length > 1 && (
                    <div className="w-full text-right">
                      <button
                        className="text-primary text-xs font-medium"
                        type="button"
                        onClick={() => removeFile2(index)}
                      >
                        Remove
                      </button>
                    </div>
                  )}
                </div>
              ))}
              <p
                className="text-primary text-xs text-right font-medium mb-4 cursor-pointer"
                onClick={() => addFormField3()}
              >
                Add more +
              </p>
             
            </div> */}

        </form>
      </div>
      {/* <div className="flex justify-center mx-auto sm:mt-20  ">
        <Button.Primary
          type={"button"}
          title={creating ? <Beat color={"#ffffff"} /> : "Create Shipper"}
          className={"w-[135px] rounded-sm "}
          onClick={checkSubmit}
        />
      </div> */}
    </div>
  );
}
